<template>
  <div v-loading="loading" class="w-full">
    <div class="flex justify-end py-3">
      <el-button v-if="showSaveLogisticsModify()" size="mini" style="font-size: 12px" type="primary"
        @click="saveLogisticsModifyForm">Save</el-button>
      <el-button v-if="showSignBtn()" size="mini" style="font-size: 12px" type="primary"
        @click="doSign">Sign</el-button>
      <el-button v-if="showSave()" size="mini" style="font-size: 12px" type="primary" @click="save">Save</el-button>
      <!-- <el-button v-if="showDownloadAfterLoadingPdf()" size="mini" type="primary" @click="getAfterLoadingFormsPdf"
        :loading="isLoadingExportPdf">Download All Forms</el-button> -->
      <el-button type="primary" :loading="subbtns" size="mini" v-if="showSignAndSubmitBtn()"
        @click="handlsignsubmitClick">
        {{ $t("btn.signasubmit") }}
      </el-button>

      <el-button v-if="showResetSignature()" type="primary" size="mini" @click="handleeResetClick">
        {{ $t("btn.ReserSignature") }}
      </el-button>
      <el-button plain size="mini" style="font-size: 12px" type="primary" @click="goBack">Close</el-button>
    </div>
    <div class="flex flex-row w-full">
      <div class="flex mr-4 flex-col ="
        style="background-color: white; border-top-left-radius: 10px;border-top-right-radius: 10px; width: 300px;">
        <div v-for="(item, index) in sidebarList" :key="item.name">
          <div class="sidebar-item items-center flex" :class="{ active: activeSidebarItem.name === item.name }"
            @click="selectSidebarItem(index, item)">
            <div
              :style="{ background: checkAllFormStatus(item) === 1 ? '#1CBB19' : '#fff', borderColor: checkAllFormStatus(item) === 1 ? '#1CBB19' : '' }"
              class="circle" style="display: flex">
              <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>

            </div>
            <div class="text-center f-500">{{ item.name }}</div>
          </div>
          <div v-if="activeSidebarItem.name.includes('Sequence') && item.name === activeSidebarItem.name"
            class="sidebar-content">
            <h1 style="font-size: 16px; font-weight: 600;">Operation Information</h1>
            <strong>Operation Type:</strong>
            <p>{{ item.details.operationType }}</p>
            <strong>Nominated Qty:</strong>
            <p>{{ item.details.nominatedQtyMax }}</p>
            <strong>Tank(s):</strong>
            <p>{{ item.details.tanks }}</p>
            <strong>Product:</strong>
            <p>{{ item.details.product }}</p>
            <strong>Doc:</strong>
            <p>{{ item.details.doc }}</p>
            <strong>Remarks:</strong>
            <p>{{ item.details.remarks }}</p>
          </div>
        </div>

      </div>

      <div class="flex flex-col w-4/5" style="background-color: white; border-radius: 10px;">
        <template v-if="activeSidebarItem.name.includes('Sequence')">
          <div class="hidden content md:block" style="background-color: white; border-radius: 10px;">
            <div class="w-full flex">
              <div v-for="(item, index) in sequenceList" :key="item.name" :class="returnClass(sequenceList, index)"
                class="w-full text-center cursor-pointer p-2 flex flex-col" @click="clickSequence(item, index)">
                <div>{{ item.name }}</div>
                <div v-if="item.name.includes('Before')"
                  style="width: 100%;display: flex;align-items: center;justify-content: center">
                  <template>
                    <div class="items-center" style="display: flex">
                      <div
                        :style="{ background: isTerminalSignedSeqBefore ? '#1CBB19' : '#fff', borderColor: isTerminalSignedSeqBefore ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Terminal Signed</div>
                    </div>
                    <div class=" items-center ml-6" style="display: flex">
                      <div
                        :style="{ background: isVesselSignedSeqBefore ? '#1CBB19' : '#fff', borderColor: isVesselSignedSeqBefore ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Vessel Signed</div>
                    </div>
                  </template>
                </div>
                <div v-if="item.name.includes('After')"
                  style="width: 100%;display: flex;align-items: center;justify-content: center">
                  <template>
                    <div class="items-center" style="display: flex">
                      <div
                        :style="{ background: isTerminalSignedSeqAfter ? '#1CBB19' : '#fff', borderColor: isTerminalSignedSeqAfter ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Terminal Signed</div>
                    </div>
                    <div class=" items-center ml-6" style="display: flex">
                      <div
                        :style="{ background: isVesselSignedSeqAfter ? '#1CBB19' : '#fff', borderColor: isVesselSignedSeqAfter ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Vessel Signed</div>
                    </div>
                  </template>
                </div>
                <div v-if="item.name.includes('Certificate')"
                  style="width: 100%;display: flex;align-items: center;justify-content: center">
                  <template>
                    <div class=" items-center px-2" style="display: flex">
                      <div
                        :style="{ background: isTerminalSignedCert ? '#1CBB19' : '#fff', borderColor: isTerminalSignedCert ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Terminal Signed</div>
                    </div>
                    <div class="items-center px-2" style="display: flex" v-if="activeSequenceType == 'Loading'">
                      <div
                        :style="{ background: isVesselSignedCert ? '#1CBB19' : '#fff', borderColor: isVesselSignedCert ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Vessel Signed</div>
                    </div>

                  </template>
                </div>
              </div>
            </div>
            <div class="flex w-full">
              <div @click="clickSequenceChild(item, index)"
                :class="{ activeChild: activeSequenceChild === index, start: index === 0, end: index === sequenceList[active].children.length - 1 }"
                v-for="(item, index) in sequenceList[active].children" :key="item.name"
                class="w-full text-center item  cursor-pointer p-2"
                style="border-top: none;border-bottom: none;flex-wrap: wrap">
                <div class="name">{{ item.name }}</div>
                <div v-if="item.type" style="width: 100%;display: flex;align-items: center;justify-content: center">
                  <template>
                    <div class="items-center" style="display: flex">
                      <div
                        :style="{ background: getSequenceStatus(item.name) === 1 ? '#1CBB19' : '#fff', borderColor: getSequenceStatus(item.name) === 1 ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Terminal</div>
                    </div>
                    <div class=" items-center ml-6" style="display: flex">
                      <div
                        :style="{ background: getSequenceStatus(item.name) === 1 ? '#1CBB19' : '#fff', borderColor: getSequenceStatus(item.name) === 1 ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Vessel</div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="block mt-5 before-form md:hidden w-full"
            style="border-top-left-radius: 10px;border-top-right-radius: 10px;background-color:#fff;">
            <div class="content mt-5" style="border-top-left-radius: 10px;border-top-right-radius: 10px;border:none;">
              <div class="flex">
                <div v-for="(item, index) in sequenceList" :key="item.name"
                  :class="{ active: active === index, start: index === 0, end: index === sequenceList.length - 1 }"
                  class=" w-full text-center item  cursor-pointer p-2 f-400"
                  style="border-top: none;height: unset;border: none "
                  @click="val = item.children[0].name; active = index; activeChild = 0; activeCom = sequenceList[index].children[0].component">
                  <div>{{ item.name }}</div>
                </div>
              </div>
            </div>
            <el-select v-model="val" class="w-full" @change="changeCom">
              <el-option v-for="item in sequenceList[active].children" :label="item.name" :value="item.name">
                <template>
                  <div class="flex justify-between p-1">
                    <div>{{ item.name }}</div>
                    <div v-if="item.type"
                      style="width: 200px;display: flex;align-items: center;justify-content: center;">
                      <div v-if="item.type == 1 || item.type == 2" class="items-center px-2" style="display: flex">
                        <div
                          :style="{ background: getSequenceStatus(item.name) === 1 ? '#1CBB19' : '#fff', borderColor: getSequenceStatus(item.name) === 1 ? '#1CBB19' : '' }"
                          class="circle" style="display: flex">
                          <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                        </div>
                        <div style="font-size: 12px">Terminal</div>
                      </div>
                      <div v-if="item.type == 1 || item.type == 8" class=" items-center px-2" style="display: flex">
                        <div
                          :style="{ background: getSequenceStatus(item.name) === 1 ? '#1CBB19' : '#fff', borderColor: getSequenceStatus(item.name) === 1 ? '#1CBB19' : '' }"
                          class="circle" style="display: flex">
                          <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                        </div>
                        <div style="font-size: 12px">Vessel</div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-option>
            </el-select>
          </div>
        </template>
        <template v-if="activeSidebarItem.name === 'Before Loading Checklists'">
          <div class="hidden content md:block" style="border-top-left-radius: 10px;border-top-right-radius: 10px;">
            <div class="w-full flex">
              <div v-for="(item, index) in list" :key="item.name" :class="returnClass(list, index)"
                class=" w-full text-center item  cursor-pointer p-2 f-500 flex flex-col"
                style="border-top: none; border-radius: 0;" @click="clickBefore(item, index)">
                <div>{{ item.name }}</div>
                <div v-if="item.type" style="width: 100%;display: flex;align-items: center;justify-content: center">
                  <template>
                    <div class="items-center" style="display: flex">
                      <div
                        :style="{ background: isTerminalSignedBefore ? '#1CBB19' : '#fff', borderColor: isTerminalSignedBefore ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Terminal Signed</div>
                    </div>
                    <div class=" items-center ml-6" style="display: flex">
                      <div
                        :style="{ background: isVesselSignedBefore ? '#1CBB19' : '#fff', borderColor: isVesselSignedBefore ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Vessel Signed</div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="flex w-full">
              <div @click="clickBeforeChild(item, index)"
                :class="{ activeChild: activeChild === index, start: index === 0, end: index === list[active].children.length - 1 }"
                v-for="(item, index) in list[active].children" :key="item.name"
                class="w-full text-center item  cursor-pointer p-2"
                style="border-top: none;border-bottom: none;flex-wrap: wrap">
                <div class="name">{{ item.name }}</div>
                <div v-if="item.type" style="width: 100%;display: flex;align-items: center;justify-content: center">
                  <template v-if="item.type == 1">
                    <div class="items-center" style="display: flex">
                      <div
                        :style="{ background: statusObj[item.status] == 2 || statusObj[item.status] == 1 ? '#1CBB19' : '#fff', borderColor: statusObj[item.status] == 2 || statusObj[item.status] == 1 ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Terminal</div>
                    </div>
                    <div class=" items-center ml-6" style="display: flex">
                      <div
                        :style="{ background: statusObj[item.status] == 3 || statusObj[item.status] == 1 ? '#1CBB19' : '#fff', borderColor: statusObj[item.status] == 3 || statusObj[item.status] == 1 ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Vessel</div>
                    </div>
                  </template>
                  <template v-if="item.type == 2">
                    <div class="items-center" style="display: flex">
                      <div
                        :style="{ background: statusObj[item.status] == 2 || statusObj[item.status] == 1 ? '#1CBB19' : '#fff', borderColor: statusObj[item.status] == 2 || statusObj[item.status] == 1 ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Terminal</div>
                    </div>
                  </template>
                  <template v-if="item.type == 8">
                    <div class=" items-center" style="display: flex">
                      <div
                        :style="{ background: statusObj[item.status] == 3 || statusObj[item.status] == 1 ? '#1CBB19' : '#fff', borderColor: statusObj[item.status] == 3 || statusObj[item.status] == 1 ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Vessel</div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="block mt-5 before-form md:hidden w-full"
            style="border-top-left-radius: 10px;border-top-right-radius: 10px;background-color:#fff;">
            <div class="content mt-5" style="border-top-left-radius: 10px;border-top-right-radius: 10px;border:none;">
              <div class="flex">
                <div v-for="(item, index) in list" :key="item.name"
                  :class="{ active: active === index, start: index === 0, end: index === list.length - 1 }"
                  class=" w-full text-center item  cursor-pointer p-2 f-400"
                  style="border-top: none;height: unset;border: none "
                  @click="val = item.children[0].name; active = index; activeChild = 0; activeCom = list[index].children[0].component">
                  <div>{{ item.name }}</div>
                </div>
              </div>
            </div>
            <el-select v-model="val" class="w-full" @change="changeCom">
              <el-option v-for="item in list[active].children" :label="item.name" :value="item.name">
                <template>
                  <div class="flex justify-between p-1">
                    <div>{{ item.name }}</div>
                    <div v-if="item.type"
                      style="width: 200px;display: flex;align-items: center;justify-content: center;">
                      <div v-if="item.type == 1 || item.type == 2" class="items-center px-2" style="display: flex">
                        <div
                          :style="{ background: statusObj[item.status] == 2 || statusObj[item.status] == 1 ? '#1CBB19' : '#fff', borderColor: statusObj[item.status] == 2 || statusObj[item.status] == 1 ? '#1CBB19' : '' }"
                          class="circle" style="display: flex">
                          <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                        </div>
                        <div style="font-size: 12px">Terminal</div>
                      </div>
                      <div v-if="item.type == 1 || item.type == 8" class=" items-center px-2" style="display: flex">
                        <div
                          :style="{ background: statusObj[item.status] == 3 || statusObj[item.status] == 1 ? '#1CBB19' : '#fff', borderColor: statusObj[item.status] == 3 || statusObj[item.status] == 1 ? '#1CBB19' : '' }"
                          class="circle" style="display: flex">
                          <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                        </div>
                        <div style="font-size: 12px">Vessel</div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-option>
            </el-select>
          </div>
        </template>
        <template v-if="activeSidebarItem.name === 'After Loading Checklists'">
          <div class="hidden content md:block" style="border-top-left-radius: 10px;border-top-right-radius: 10px;">
            <div style="width: 100%;display: flex;align-items: center;justify-content: center">
              <template>
                <div class="flex flex-col active p-2"
                  style="width: 100%;display: flex;align-items: center;justify-content: center">
                  After Loading Checklist
                  <div class="flex flex-row">

                    <div class="items-center" style="display: flex">
                      <div
                        :style="{ background: isTerminalSignedAfter ? '#1CBB19' : '#fff', borderColor: isTerminalSignedAfter == 1 ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Terminal Signed</div>
                    </div>
                    <div class=" items-center ml-6" style="display: flex">
                      <div
                        :style="{ background: isVesselSignedAfter ? '#1CBB19' : '#fff', borderColor: isVesselSignedAfter ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Vessel Signed</div>
                    </div>
                  </div>

                </div>
              </template>
            </div>
            <div class="flex">

              <div style="border-top: none;border-bottom: none;flex-wrap: wrap"
                @click="activeAfter = index; activeCom = item.component; updateForm()"
                v-for="(item, index) in listAfter" :key="item.name" class="w-full text-center item  cursor-pointer p-2"
                :class="{ activeChild: activeAfter === index, start: index === 0, end: index === listAfter.length - 1, light: statusObj[item.status] === 1 }">
                <div>{{ item.name }}</div>
                <div v-if="item.type" style="width: 100%;display: flex;align-items: center;justify-content: center">
                  <template v-if="item.type == 1">
                    <div class="items-center" style="display: flex">
                      <div
                        :style="{ background: statusObj[item.status] == 2 || statusObj[item.status] == 1 ? '#1CBB19' : '#fff', borderColor: statusObj[item.status] == 2 || statusObj[item.status] == 1 ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Terminal</div>
                    </div>
                    <div class=" items-center ml-6" style="display: flex">
                      <div
                        :style="{ background: statusObj[item.status] == 3 || statusObj[item.status] == 1 ? '#1CBB19' : '#fff', borderColor: statusObj[item.status] == 3 || statusObj[item.status] == 1 ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Vessel</div>
                    </div>
                  </template>
                  <template v-if="item.type == 2">
                    <div class="items-center" style="display: flex">
                      <div
                        :style="{ background: statusObj[item.status] == 2 || statusObj[item.status] == 1 ? '#1CBB19' : '#fff', borderColor: statusObj[item.status] == 2 || statusObj[item.status] == 1 ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Terminal</div>
                    </div>
                  </template>
                  <template v-if="item.type == 8">
                    <div class=" items-center" style="display: flex">
                      <div
                        :style="{ background: statusObj[item.status] == 3 || statusObj[item.status] == 1 ? '#1CBB19' : '#fff', borderColor: statusObj[item.status] == 3 || statusObj[item.status] == 1 ? '#1CBB19' : '' }"
                        class="circle" style="display: flex">
                        <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                      </div>
                      <div style="font-size: 12px">Vessel</div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="block md:hidden w-full"
            style="border-top-left-radius: 10px;border-top-right-radius: 10px;background-color:#fff;">
            <el-select v-model="val1" class="w-full" @change="changeAfter">
              <el-option v-for="(item, index) in listAfter" :label="item.name" :value="item.name">
                <template>
                  <div class="flex justify-between p-1">
                    <div>{{ item.name }}</div>
                    <div v-if="item.type"
                      style="width: 200px;display: flex;align-items: center;justify-content: center;">
                      <div v-if="item.type == 1 || item.type == 2" class="items-center px-2" style="display: flex">
                        <div
                          :style="{ background: statusObj[item.status] == 2 || statusObj[item.status] == 1 ? '#1CBB19' : '#fff', borderColor: statusObj[item.status] == 2 || statusObj[item.status] == 1 ? '#1CBB19' : '' }"
                          class="circle" style="display: flex">
                          <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                        </div>
                        <div style="font-size: 12px">Terminal</div>
                      </div>
                      <div v-if="item.type == 1 || item.type == 8" class=" items-center px-2" style="display: flex">
                        <div
                          :style="{ background: statusObj[item.status] == 3 || statusObj[item.status] == 1 ? '#1CBB19' : '#fff', borderColor: statusObj[item.status] == 3 || statusObj[item.status] == 1 ? '#1CBB19' : '' }"
                          class="circle" style="display: flex">
                          <i class="el-icon-check" style="color: #fff;font-size: 12px"></i>
                        </div>
                        <div style="font-size: 12px">Vessel</div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-option>
            </el-select>
          </div>
        </template>
        <div class="pl-2 pr-2 w-full"
          style="background-color: white; border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;">
          <component :is="activeCom" :nominationData="data" :disabled="disabled" :modifyReason="modifyForm.modifyReason"
            :logisticsModify="allowLogisticsModifyForm" :sign="sign" :operationId="activeSequenceId"
            :beforeAfterFlag="beforeAfterFlag" @update="update" :bid="bid" :operationType="activeSequenceType"
            :sign_type="activeSignType" @lists="lists" :ref="this.val === 'Certificate' ? 'Listcertificates' : 'form'">
          </component>

        </div>
        <sign-document-dialog ref="documentdialog" :bid="this.bid" :docs="this.docs" :vesselName="this.data.vesselName"
          :operationId="activeSequenceId" @update="checkAllFormStatus()" />
        <juput-reset-dialog ref="juptResetDialog" :bid="this.bid" :operationId="this.activeSequenceId" />
        <sign-document ref="signRef" :visible.sync="signShow" @close="signShow = false" @signSubmit="signSubmit"
          @update="checkAllFormStatus()" :operationId="this.activeSequenceId"></sign-document>
      </div>
      <el-dialog title="Reason to Modify" :visible.sync="modifyReasonDialogVisible"
        :width="isMobileScreen ? '100%' : '500px'" @click="resetLogisticsModifyForm()">
        <div>
          <el-form :model="modifyForm" label-width="auto" size="mini" label-position="top" ref="modifyForm"
            :rules="rules">
            <el-form-item label="Please state the reason to modify:" prop="modifyReason">
              <el-input type="textarea" v-model="modifyForm.modifyReason" clearable size="small"
                :style="{ width: '100%' }"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <template #footer>
          <div class="dialog-footer">
            <el-button plain type="primary" size="mini" @click="resetLogisticsModifyForm()">{{ $t("btn.close")
              }}</el-button>
            <el-button type="primary" size="mini" @click="submitLogisticsModifyForm()">{{ $t("btn.submit")
              }}</el-button>
          </div>
        </template>
      </el-dialog>

    </div>

  </div>
</template>
<script>
import StatusLine from "@/view/vessel/components/statusLine.vue";
import PollutionPrevention from "@/view/vessel/components/formComponents/PollutionPrevention.vue";
import AfterMooring from "@/view/vessel/components/formComponents/AfterMooring.vue";
import PilotMovement from "@/view/vessel/components/formComponents/PilotMovement.vue";
import PolotLadderDeclaration from "@/view/vessel/components/formComponents/PilotLadderDeclaration.vue";

import PreTransfer from "@/view/vessel/components/formComponents/PreTransfer.vue";
import RepetitiveChecksTanker from "@/view/vessel/components/formComponents/RepetitiveChecksTanker.vue";
import SafatyRequirements from "@/view/vessel/components/formComponents/SafatyRequirements.vue";
import RequiredOnDeck from "@/view/vessel/components/formComponents/RequiredOnDeck.vue";

import RepetitiveChecksTerminal from "@/view/vessel/components/formComponents/RepetitiveChecksTerminal.vue";
import PurchaseAndSale from "@/view/vessel/components/formComponents/PurchaseAndSale.vue";
import WalkieTalkie from "@/view/vessel/components/formComponents/WalkieTalkie.vue";
import UllageReport from "@/view/vessel/components/formComponents/UllageReport.vue";
import DeclarationOfSecurity from "@/view/vessel/components/formComponents/DeclarationOfSecurity.vue";
import SignDocument from "@/view/vessel/components/signDocument.vue";

import ReceiptOfWalkie from "@/view/vessel/components/formComponents/ReceiptOfWalkie.vue";
import UllageReportEs from "@/view/vessel/components/formComponents/UllageReportEs.vue";
import TimeSheet from "@/view/vessel/components/formComponents/TimeSheet.vue";
import PreLoading from "@/view/vessel/components/formComponents/PreLoading.vue";
import ReceiptOfSamples from "@/view/vessel/components/formComponents/ReceiptOfSamples.vue";
import CargoNomination from "@/view/vessel/components/formComponents/CargoNomination.vue";
import SignDocumentDialog from "@/view/vessel/components/sign-document-dialog.vue";
import { downloadAfterLoadingFormsPdf, signVesselForm } from "@/services/form";
import { downloadFile } from "@/services";
import certificates from "./certificates.vue";
import JuputResetDialog from "@/view/vessel/components/juput-reset-dialog.vue";

export default {
  name: 'VesselForm',
  components: { SignDocument, StatusLine, SignDocumentDialog, JuputResetDialog },
  props: {
    data: {
      type: Object,
    },
    status: {
      type: Object,
    },
    bid: {
      type: String,
    }
  },
  data() {
    return {
      statusObj: {},
      signShow: false,
      val: '',
      val1: '',
      list: [
        {
          name: 'Checklist',
          type: '1',
          children: [
            {
              name: 'Pollution Prevention',
              component: PollutionPrevention,
              status: 'checkPollutionPreventionStatus',
              type: '1'
            },
            {
              name: 'After Mooring',
              component: AfterMooring,
              status: 'checkPollutionMooringStatus',
              type: '1'
            },
            {
              name: 'Pre-Transfer',
              component: PreTransfer,
              status: 'checkPollutionTransferStatus',
              type: '1'
            },
            {
              name: 'Repetitive Checks - Tanker',
              component: RepetitiveChecksTanker,
              status: 'checkPollutionTankerBeforeStatus',
              type: '8'
            },
            {
              name: 'Repetitive Checks - Terminal',
              component: RepetitiveChecksTerminal,
              status: 'checkPollutionTerminalBeforeStatus',
              type: '2'
            },
          ]
        },
        {
          name: 'Declaration',
          type: '1',
          children: [
            {
              name: "Vessel's Checklist for Pilot Movement",
              component: PilotMovement,
              status: 'declarationMovementStatus',
              type: '8'
            },
            {
              name: 'Pilot Ladder Declaration',
              component: PolotLadderDeclaration,
              status: 'declarationDeclarationStatus',
              type: '8'
            },
            {
              name: 'Safety Requirements',
              component: SafatyRequirements,
              status: 'declarationRequirementsStatus',
            },
            {
              name: 'Number of Watch Crew Required on Deck',
              component: RequiredOnDeck,
              status: 'declarationDeckStatus',
              type: '8'
            },
            {
              name: 'Declaration on the Use,Purchase and Sale',
              component: PurchaseAndSale,
              status: 'declarationSaleStatus',
              type: '8'
            },
            {
              name: 'Issue of Walkie Talkie',
              component: WalkieTalkie,
              status: 'declarationTalkieStatus',
              type: '2'
            },
            {
              name: 'Pre-Loading/Pre-Discharging Information',
              component: PreLoading,
              status: 'afterInformationStatus',
              type: '1'
            },
            {
              name: 'Cargo Nomination',
              component: CargoNomination,
              status: 'afterNominationStatus',
              type: '1'
            },
            {
              name: 'Declaration of Security',
              component: DeclarationOfSecurity,
              status: 'declarationSecurityStatus',
              type: '1'
            },
          ]
        }
      ],
      listAfter: [
        {
          name: 'Receipt of Walkie Talkie',
          component: ReceiptOfWalkie,
          status: 'afterTalkieStatus',
          type: '2'
        },

        {
          name: 'Receipt of Samples',
          component: ReceiptOfSamples,
          status: 'afterSamplesStatus',
          type: '1'
        },
        {
          name: 'Repetitive Checks - Tanker',
          component: RepetitiveChecksTanker,
          status: 'checkPollutionTankerAfterStatus',
          type: '8'
        },
        {
          name: 'Repetitive Checks - Terminal',
          component: RepetitiveChecksTerminal,
          status: 'checkPollutionTerminalAfterStatus',
          type: '2'
        },
      ],
      sequenceList: [
        {
          name: 'Before Forms',
          type: '1',
          children: [
            {
              name: 'Ullage Report',
              component: UllageReport,
              status: 'ullageStatus',
              type: '1'
            },
            {
              name: 'Time Sheet',
              component: TimeSheet,
              status: 'timeSheetStatus',
              type: '1'
            },
          ]
        },
        {
          name: 'After Forms',
          type: '1',
          children: [
            {
              name: 'Ullage Report',
              component: UllageReportEs,
              status: 'ullageStatus',
              type: '1'
            },
            {
              name: 'Time Sheet',
              component: TimeSheet,
              status: 'timeSheetStatus',
              type: '1'
            },
          ]
        },
        {
          name: 'Certificate',
          component: certificates,
          status: 'certificateStatus',
          type: '1'
        },
      ],

      sidebarList: [],
      active: 0,
      activeChild: 0,
      activeCom: 'beforeLoadingChecklists',
      activeSequence: 0,
      activeSequenceChild: 0,
      activeSequenceId: '',
      activeSequenceType: '',
      activeSignType: 0,
      activeLoadingType: 0,
      activeAfter: 0,
      activeSidebarItem: {},
      beforeAfterFlag: 0, // 0 for before loading, 1 for after loading
      activeComponent: null,
      isShow: false,
      sign: {
        terminal: {},
        barge: {},
        terminalB: {},
        bargeB: {}
      },
      loading: false,
      allowLogisticsModifyForm: false,
      modifyReasonDialogVisible: false,
      modifyForm: {
        modifyReason: "",
      },
      rules: {
        modifyReason: [
          { required: true, message: 'Reason cannot be empty', trigger: 'blur' },
          { required: true, transform: (values) => values && values.trim(), message: 'Reason cannot be empty', trigger: 'blur' },
        ],
      },
      isLoadingExportPdf: false,
      isTerminalSignedBefore: false,
      isVesselSignedBefore: false,
      isVesselSignedAfter: false,
      isTerminalSignedAfter: false,
      isTerminalSignedSeqBefore: false,
      isVesselSignedSeqBefore: false,
      isVesselSignedSeqAfter: false,
      isTerminalSignedSeqAfter: false,
      isVesselSignedCert: false,
      isTerminalSignedCert: false,
      sequenceFormStatus: [],
      isBeforeSigned: false,
      isAfterSigned: false,
      isSeqSigned: false,
      docs: []
    }
  },
  watch: {
    activeSidebarItem: {
      handler(newSideBar) {
        this.sign = {
          terminal: {},
          barge: {},
          terminalB: {},
          bargeB: {},
        };
        this.getSequenceStatus();
        this.fetchVesselOperations();
        this.checkAllFormStatus();
        this.checkFormStatus();

        this.$nextTick(() => {
          this.fetchSign();
        });
      },
      deep: true,
      immediate: true,
    },
    sequenceFormStatus: {
      handler(newStatus) {
        this.getSequenceStatus();
        this.fetchVesselOperations();
        this.checkAllFormStatus();
      },
      deep: true,
      immediate: true,
    },
    activeSequenceId: {
      handler(newId) {
        this.sign = {
          terminal: {},
          barge: {},
          terminalB: {},
          bargeB: {},
        };
        this.getSequenceStatus();
        this.checkFormStatus();
        this.fetchVesselOperations();
        this.checkAllFormStatus();
      },
      deep: true,
      immediate: true,
    },
    status: {
      handler(newV) {
        this.active = 0
        const num = 0
        this.activeChild = num
        this.activeCom = this.list[this.active].children[num].component
        this.val = this.list[this.active].children[num].name
        this.isShow = true
        this.fetchVesselOperations();
      },
      deep: true,
      immediate: true
    },
    data: {
      handler(newV) {
        if (newV) {
          this.statusObj = {
            ...newV.nominationFormStatus
          }
          this.checkFormStatus()
          this.fetchVesselOperations();
          this.checkAllFormStatus();

        }
      },
      deep: true,
      immediate: true,
    },
    sequenceFormStatus: {
      handler(newStatus) {
        this.getSequenceStatus()

      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    disabled() {
      const editableForm = this.activeCom.name == "RecordingReport" || this.activeCom.name == "MeterReadingReport" || this.activeCom.name == "UllageReport" || this.activeCom.name == "TimeSheet";
      const isLogisticsRole = this.$store.state.userInfo.role == '1';
      const isCompltedNomination = this.data.status == '4';
      if (editableForm && isLogisticsRole && isCompltedNomination) {
        this.allowLogisticsModifyForm = true
        return false
      }

      if (this.activeCom.name == "MeterReadingReport" || this.activeCom.name == "RecordingReport") {
        if (this.userInfo.role === '11' && (this.data.status == 2 || this.data.status == 3)) {
          return false
        }
        return true
      }

      if (this.data.status == 2 || this.data.status == 3) {
        if (this.userInfo.role === '11' || this.userInfo.role === '8') {
          var isTerminalSigned = this.data.formsSigns.some(
            (item) => item.signType === 1 && item.type === 2 && item.operationId === this.activeSequenceId
          );

          var isVesselSigned = this.data.formsSigns.some(
            (item) => item.signType === 1 && item.type === 1 && item.operationId === this.activeSequenceId
          );
          if ((this.val == 'Ullage Report' || this.val == 'Time Sheet') && this.beforeAfterFlag == 1 && (!isTerminalSigned || !isVesselSigned)) {
            return true
          }
          if (this.activeSidebarItem.name === 'After Loading Checklists' && !this.isBeforeSigned) {
            return true
          }
          return false
        }
      }

      return true
    },

  },
  mounted() {
    this.fetchVesselOperations().then(() => {
      this.activeSidebarItem = this.sidebarList[0];
      this.activeComponent = this.sidebarList[0]?.component || null;
      this.checkFormStatus();
    });
  },
  methods: {
    async fetchVesselOperations() {
      try {
        const vesselOperations = this.data.vesselOperations || [];
        const ullageStatusList = (this.data.nominationFormStatus.ullageStatusList || []).filter(
          (status) => status.operationId !== null
        );
        const sheetStatusList = this.data.nominationFormStatus.sheetStatusList || [];

        const validOperations = vesselOperations.filter(operation => operation.id !== null);

        const operationsSidebarList = validOperations.map((operation, index) => ({
          name: `Sequence ${index + 1}`,
          component: `sequence${index + 1}`,
          details: {
            operationId: operation.id,
            nominatedQtyMax: operation.nominatedQtyMax,
            tanks: operation.operationTanks.map(tank => tank.tankName).join(', '),
            product: operation.product,
            doc: operation.doc,
            remarks: operation.remarks,
            operationType: operation.operationType,
            signType: operation.signType || 0,
            loadingType: operation.loadingType || 0
          },
        }));

        this.sequenceFormStatus = validOperations.map((operation) => {
          const ullageStatus = ullageStatusList.find(
            (op) => op.operationId === operation.id
          ) || { beforeUllageStatus: 0, afterUllageStatus: 0 };

          const sheetStatus = sheetStatusList.find(
            (op) => op.operationId === operation.id
          ) || { beforeSheetStatus: 0, afterSheetStatus: 0 };

          return {
            operationId: operation.id,
            beforeUllageStatus: ullageStatus.beforeUllageStatus ?? 0,
            afterUllageStatus: ullageStatus.afterUllageStatus ?? 0,
            beforeSheetStatus: sheetStatus.beforeSheetStatus ?? 0,
            afterSheetStatus: sheetStatus.afterSheetStatus ?? 0,
          };
        });

        this.sidebarList = [
          { name: 'Before Loading Checklists', component: 'beforeLoadingChecklists' },
          ...operationsSidebarList,
          { name: 'After Loading Checklists', component: 'afterLoadingChecklists' },
        ];
        return Promise.resolve();
      } catch (error) {
        console.error("Error fetching vessel operations:", error);
        return Promise.reject(error);
      }
    },
    update() {
      this.updateForm()
      this.loading = false
    },
    updateForm() {
      this.$emit('update')
    },
    returnClass(arrList, index) {
      const arr = []
      if (this.active === index) {
        arr.push('active')
      }
      if (index === 0) {
        arr.push('start')
      }
      if (index === arrList.length - 1) {
        arr.push('end')
      }
      return arr
    },
    showResetSignature() {
      return this.userInfo.role == '3' && !this.isRequest() && this.activeSidebarItem.name.includes('Sequence') && this.val === 'Certificate' && this.activeSignType > 1 && this.data.status > 1;
    },
    isRequest() {
      return this.data.requestStatus == 1 && this.data.status != 4;
    },
    checkFormStatus() {
      if (!this.data || !this.data.formsSigns) {
        console.warn("formsSigns is undefined or not initialized.");
        return;
      }

      this.isTerminalSignedBefore = this.data.formsSigns.some(
        (item) => item.signType === 1 && item.type === 2 && item.operationId == null
      );
      this.isVesselSignedBefore = this.data.formsSigns.some(
        (item) => item.signType === 1 && item.type === 1 && item.operationId == null
      );
      this.isTerminalSignedAfter = this.data.formsSigns.some(
        (item) => item.signType === 2 && item.type === 2 && item.operationId == null
      );
      this.isVesselSignedAfter = this.data.formsSigns.some(
        (item) => item.signType === 2 && item.type === 1 && item.operationId == null
      );

      this.isTerminalSignedSeqBefore = this.data.formsSigns.some(
        (item) => item.signType === 1 && item.type === 2 && item.operationId === this.activeSequenceId
      );
      this.isTerminalSignedSeqAfter = this.data.formsSigns.some(
        (item) => item.signType === 2 && item.type === 2 && item.operationId === this.activeSequenceId
      );
      this.isVesselSignedSeqBefore = this.data.formsSigns.some(
        (item) => item.signType === 1 && item.type === 1 && item.operationId === this.activeSequenceId
      );
      this.isVesselSignedSeqAfter = this.data.formsSigns.some(
        (item) => item.signType === 2 && item.type === 1 && item.operationId === this.activeSequenceId
      );

      if (this.data.vesselOperations.some(item => item.signType === 3 && item.id === this.activeSequenceId)) {
        this.isVesselSignedCert = true;
        this.isTerminalSignedCert = true;
      } else if (this.data.vesselOperations.some(item => item.signType === 2 && item.id === this.activeSequenceId)) {
        this.isTerminalSignedCert = true;
      }
      this.fetchSign();
    },

    checkAllFormStatus(item) {
      if (!item || !item.name) {
        return 0;
      }
      if (item.name.includes('Before')) {
        this.isBeforeSigned = this.isTerminalSignedBefore && this.isVesselSignedBefore;
        return this.isBeforeSigned ? 1 : 0;
      } else if (item.name.includes('After')) {
        this.isAfterSigned = this.isTerminalSignedAfter && this.isVesselSignedAfter;
        return this.isAfterSigned ? 1 : 0;
      } else if (item.name.includes('Sequence')) {
        const operation = this.sequenceFormStatus.find(op => op.operationId === item.details.operationId);

        if (!operation) {
          console.warn('Operation not found for operationId:', item.details.operationId);
          return 0;
        }

        const isTerminalSignedBefore = this.data.formsSigns.some(
          (sign) => sign.signType === 1 && sign.type === 2 && sign.operationId === item.details.operationId
        );
        const isVesselSignedBefore = this.data.formsSigns.some(
          (sign) => sign.signType === 1 && sign.type === 1 && sign.operationId === item.details.operationId
        );
        const isTerminalSignedAfter = this.data.formsSigns.some(
          (sign) => sign.signType === 2 && sign.type === 2 && sign.operationId === item.details.operationId
        );
        const isVesselSignedAfter = this.data.formsSigns.some(
          (sign) => sign.signType === 2 && sign.type === 1 && sign.operationId === item.details.operationId
        );
        let isCertSigned = false;
        if (item.details.operationType == 'Loading') {
          isCertSigned = this.data.vesselOperations.some(op => op.signType === 3 && op.id === item.details?.operationId)
        } else if (item.details.operationType == 'Discharge') {
          isCertSigned = this.data.vesselOperations.some(op => op.signType === 2 && op.id === item.details?.operationId)
        } else {
          isCertSigned = false
        }
        return (isTerminalSignedBefore && isVesselSignedBefore && isTerminalSignedAfter && isVesselSignedAfter && isCertSigned) ? 1 : 0;
      }

      return 0;
    },

    fetchSign() {
      if (this.activeSequenceId) {
        if (this.isTerminalSignedSeqBefore || this.isVesselSignedSeqBefore) {
          this.sign.terminalB =
            this.data.formsSigns.filter(
              (item) => item.signType === 1 && item.type === 2 && item.operationId === this.activeSequenceId
            )[0] || {};
          this.sign.bargeB =
            this.data.formsSigns.filter(
              (item) => item.signType === 1 && item.type === 1 && item.operationId === this.activeSequenceId
            )[0] || {};
          if (this.isTerminalSignedSeqAfter || this.isVesselSignedSeqAfter) {
            this.sign.terminal =
              this.data.formsSigns.filter(
                (item) => item.signType === 2 && item.type === 2 && item.operationId === this.activeSequenceId
              )[0] || {};
            this.sign.barge =
              this.data.formsSigns.filter(
                (item) => item.signType === 2 && item.type === 1 && item.operationId === this.activeSequenceId
              )[0] || {};
          }
        }
      } else if (!this.activeSequenceId) {
        this.sign.terminal = this.data.formsSigns.filter(item => item.signType == 1 && item.type == 2 && item.operationId == null)[0] || {}
        this.sign.barge = this.data.formsSigns.filter(item => item.signType == 1 && item.type == 1 && item.operationId == null)[0] || {}
        this.sign.terminalB = this.data.formsSigns.filter(item => item.signType == 1 && item.type == 2 && item.operationId == null)[0] || {}
        this.sign.bargeB = this.data.formsSigns.filter(item => item.signType == 1 && item.type == 1 && item.operationId == null)[0] || {}
        this.sign.terminal = this.data.formsSigns.filter(item => item.signType == 2 && item.type == 2 && item.operationId == null)[0] || {}
        this.sign.barge = this.data.formsSigns.filter(item => item.signType == 2 && item.type == 1 && item.operationId == null)[0] || {}
      }
    },

    handleeResetClick() {
      this.$refs.juptResetDialog.open();
    },

    getSequenceStatus(type) {
      const operation = this.sequenceFormStatus.find(op => op.operationId === this.activeSequenceId);
      if (!operation) {
        console.warn('Operation not found for activeSequenceId:', this.activeSequenceId);
        return 0;
      }

      if (type === 'Ullage Report') {
        return this.active === 0 ? operation.beforeUllageStatus || 0 : operation.afterUllageStatus || 0;
      } else if (type === 'Time Sheet') {
        return this.active === 0 ? operation.beforeSheetStatus || 0 : operation.afterSheetStatus || 0;
      }
      return 0;
    },

    showSideBarCom(item) {
      // Reset signed certificate flags
      this.isTerminalSignedCert = false;
      this.isVesselSignedCert = false;
      this.docs = [];

      if (item.name === 'Before Loading Checklists') {
        this.activeChild = 0;
        this.activeCom = this.list[0].children[0].component;
        this.beforeAfterFlag = 0;
        this.activeSequenceId = '';
        this.val = this.list[0].children[0].name;
      } else if (item.name === 'After Loading Checklists') {
        this.activeAfter = 0;
        this.activeCom = this.listAfter[0].component;
        this.beforeAfterFlag = 1;
        this.activeSequenceId = '';
        this.val = this.listAfter[0].name;
      } else if (item.name.includes('Sequence')) {
        this.activeSequence = 0;
        this.activeSequenceChild = 0;
        this.active = 0;
        this.activeCom = this.sequenceList[0].children[0].component;
        this.activeSequenceId = item.details?.operationId || this.activeSequenceId;
        this.activeSequenceType = item.details.operationType || this.activeSequenceType;
        this.activeSignType = item.details.signType;
        this.activeLoadingType = item.details.loadingType || this.activeLoadingType;
        this.beforeAfterFlag = 0;
        this.val = this.sequenceList[0].children[0].name;

        if (this.data.vesselOperations.some(item => item.signType === 3 && item.id === this.activeSequenceId)) {
          this.isVesselSignedCert = true;
          this.isTerminalSignedCert = true;
        } else if (this.data.vesselOperations.some(item => item.signType === 2 && item.id === this.activeSequenceId)) {
          this.isTerminalSignedCert = true;
        }
      } else {
        this.activeSequenceId = '';
        console.error('Unhandled sidebar item:', item.name);
      }
    },
    selectSidebarItem(index, item) {
      this.active = index;
      this.activeSidebarItem = item;
      this.showSideBarCom(item);

      // Wait for DOM/state updates, then fetch sign
      this.$nextTick(() => {
        this.fetchSign();
      });

      this.fetchVesselOperations();
      this.checkFormStatus();
      this.checkAllFormStatus(item);
    },
    clickBeforeChild(item, index) {
      this.allowLogisticsModifyForm = false;
      this.val = item.name;
      this.activeChild = index;
      this.activeCom = item.component;
      this.updateForm();
    },
    clickBefore(item, index) {
      this.allowLogisticsModifyForm = false;
      this.val = item.children[0].name;
      this.active = index;
      this.activeChild = 0;
      this.activeCom = this.list[index].children[0].component;
      this.beforeAfterFlag = 0;

      this.activeSidebarItem = this.sidebarList.find(sidebarItem => sidebarItem.name === 'Before Loading Checklists');
    },
    clickAfterChild(item, index) {
      this.activeAfter = index;
      this.activeCom = item.component;
    },
    clickSequence(sequence, index) {
      this.allowLogisticsModifyForm = false;
      this.active = index;
      this.activeSequenceChild = 0;
      if (sequence.name === 'Certificate') {
        this.val = sequence.name;
        this.activeCom = sequence.component;
      } else {
        this.val = sequence.children[0].name;
        this.activeCom = this.sequenceList[index].children[0].component;

        if (sequence.name === 'Before Forms') {
          this.beforeAfterFlag = 0;
        } else if (sequence.name === 'After Forms') {
          this.beforeAfterFlag = 1;
        }
      }
      this.fetchVesselOperations();

      this.activeSidebarItem = this.sidebarList.find(sidebarItem => sidebarItem.name === this.activeSidebarItem.name);
    },
    clickSequenceChild(item, index) {
      this.allowLogisticsModifyForm = false;
      this.val = item.name;
      this.activeSequenceChild = index;
      this.activeCom = item.component;
      this.updateForm();
    },
    goBack() {
      this.$router.push('/vessel/index')
    },
    save() {
      this.loading = true
      this.$refs.form && this.$refs.form.save()
    },
    changeCom(val) {
      this.allowLogisticsModifyForm = false;
      const item = this.list[this.active].children.find(item => item.name === val)
      this.activeCom = item.component
    },
    changeAfter(val) {
      this.allowLogisticsModifyForm = false;
      const item = this.listAfter.find(item => item.name === val);
      const index = this.listAfter.indexOf(val);
      this.activeAfter = index;
      this.activeCom = item.component;
      this.beforeAfterFlag = 1;
      this.updateForm();
    },
    doSign() {
      this.signShow = true
      this.$nextTick(() => {
        this.$refs.signRef.clear()
      })
    },

    signSubmit(form) {
      let loadingType = this.activeSequenceId === null || this.activeSequenceId === '' ? this.data.loadingType : this.data.vesselOperations.find(op => op.id === Number(this.activeSequenceId)).loadingType
      const data = {
        name: form.name,
        eSignature: form.eSignature,
        signType: '',
        nominationId: this.$route.query.id
      }

      if (this.beforeAfterFlag == 0) {
        data.signType = 1
      }
      else if (this.beforeAfterFlag == 1) {
        data.signType = 2
      }

      if (this.activeSequenceId !== '' || this.activeSequenceId !== null) {
        signVesselForm({ ...data, operationId: this.activeSequenceId }).then(res => {
          this.$message.success('Sign Success!')
          this.signShow = false
          this.$emit('update')
        })
      } else {
        signVesselForm(data).then(res => {
          this.$message.success('Sign Success!')
          this.signShow = false
          this.$emit('update')
        })
      }
    },

    showSave() {
      if (this.$store.state.userInfo.role !== '11' && this.$store.state.userInfo.role !== '8') {
        return false
      }

      if (this.data.status == '2' || this.data.status == '3') {
        if (this.val === 'Certificate') {
          return false
        } else if (this.activeSidebarItem.name.includes('Sequence') && this.beforeAfterFlag == 1 && !(this.isVesselSignedSeqBefore && this.isTerminalSignedSeqBefore)) {
          return false
        } else if (this.activeSidebarItem.name === 'After Loading Checklists' && !this.isBeforeSigned) {
          return false
        } else {
          return true
        }
      }
    },
    showSignBtn() {
      if (this.$store.state.userInfo.role !== '11' && this.$store.state.userInfo.role !== '8') {
        return false
      }

      if (this.activeSidebarItem.name === 'Before Loading Checklists') {
        //before
        const arr = []
        this.list.map(item => {
          item.children.map(it => {
            arr.push({
              key: it.status,
              value: ''
            })
          })
        })
        arr.map(item => {
          item.value = this.statusObj[item.key]
        })


        if (this.data && this.data.formsSigns) {
          const item = this.data.formsSigns.find(item => item.createBy == this.$store.state.userInfo.userId && item.signType == 1 && item.operationId == null)
          if (item) {
            return false
          }
        }
        if (this.data.status == 2 || this.data.status == 3) {
          if (arr.every(item => item.value === 1)) {
            return true

          }
        }

      } else if (this.activeSidebarItem.name === 'After Loading Checklists') {
        const arr = []
        this.listAfter.map(item => {
          arr.push({
            key: item.status,
            value: ''
          })
        })
        arr.map(item => {
          item.value = this.statusObj[item.key]
        })
        if (this.data && this.data.formsSigns) {
          const item = this.data.formsSigns.find(item => item.createBy == this.$store.state.userInfo.userId && item.signType == 2 && item.operationId == null)
          if (item) {
            return false
          }
        }
        if (this.data.status == 2 || this.data.status == 3) {
          if (arr.every(item => item.value === 1) && this.isBeforeSigned) {
            return true
          }
        }
      } else if (this.activeSidebarItem.name.includes('Sequence')) {
        //sequence
        const operation = this.sequenceFormStatus.find(op => op.operationId === this.activeSequenceId);

        if(this.val == 'Certificate'){
          return false
        }

        // Add a check for operation
        if (!operation) {
          console.warn('Operation not found for activeSequenceId:', this.activeSequenceId);
          return false;
        }

        if (this.beforeAfterFlag === 0) {
          this.arr = [
            operation.beforeUllageStatus,
            operation.beforeSheetStatus
          ];
          if (this.data && this.data.formsSigns) {
            const item = this.data.formsSigns.find(item => item.createBy == this.$store.state.userInfo.userId && item.signType == 1 && item.operationId == this.activeSequenceId)
            if (item) {
              return false;
            }
          }
          if (this.data.status == 2 || this.data.status == 3) {
            if (this.arr.every(item => item === 1)) {
              return true;
            }
          }
        } else if (this.beforeAfterFlag === 1) {

          this.arr = [
            operation.afterUllageStatus,
            operation.afterSheetStatus
          ];
          if (this.data && this.data.formsSigns) {
            const item = this.data.formsSigns.find(item => item.createBy == this.$store.state.userInfo.userId && item.signType == 2 && item.operationId == this.activeSequenceId)
            if (item) {
              return false;
            }
          }
          if (this.data.status == 2 || this.data.status == 3) {
            if (this.arr.every(item => item === 1) && this.isVesselSignedSeqBefore && this.isTerminalSignedSeqBefore) {
              return true;
            }
          }

        }
      }
    },
    showSaveLogisticsModify() {
      const editableForm = this.activeCom.name == "UllageReport" || this.activeCom.name == "TimeSheet";
      const isLogisticsRole = this.$store.state.userInfo.role == '1';
      const isCompltedNomination = this.data.status == '4';
      return editableForm && isLogisticsRole && isCompltedNomination
    },
    saveLogisticsModifyForm() {
      this.modifyReasonDialogVisible = true;
    },
    async submitLogisticsModifyForm() {
      const isValid = await new Promise((resolve) => {
        this.$refs.modifyForm.validate((valid) => {
          if (!valid) {
            resolve(false);
          } else {
            resolve(true);
          }
        });
      });
      if (!isValid) {
        return;
      }
      this.save();
      this.resetLogisticsModifyForm();
    },
    resetLogisticsModifyForm() {
      this.$refs.modifyForm.clearValidate();
      this.modifyReasonDialogVisible = false;
      this.modifyForm.modifyReason = "";
    },

    showSignAndSubmitBtn() {
      if (this.docs.length == 0) {
        return false
      }
      if (this.activeSequenceType == 'Loading') {
        if (this.userInfo.role == 3 || this.userInfo.role == 2) {
          return !this.isTerminalSignedCert && this.activeSidebarItem.name.includes('Sequence')
            && this.val == 'Certificate'
        } else if (this.userInfo.role == 8) {
          return !this.isVesselSignedCert && this.activeSidebarItem.name.includes('Sequence')
            && this.val == 'Certificate' && this.isTerminalSignedCert
        } else {
          return false
        }
      } else {
        return !this.isTerminalSignedCert &&
          (this.userInfo.role == 3 || this.userInfo.role == 2) && this.activeSidebarItem.name.includes('Sequence')
          && this.val == 'Certificate'
      }
    },
    lists() {
      this.docs = [...this.$refs.Listcertificates?.quantityTableData, ...this.$refs.Listcertificates?.billOfLadingTableData, ...this.$refs.Listcertificates?.receiptOfSamplesTableData,
      ...this.$refs.Listcertificates?.receiptOfShippingTableData, ...this.$refs.Listcertificates?.manifestTableData];
      this.show = true;
      this.fetchVesselOperations();

    },
    showDownloadAfterLoadingPdf() {
      return this.data.status == '4' && this.$store.state.userInfo.role != 10 && this.$store.state.userInfo.role != 12
    },
    async getAfterLoadingFormsPdf() {
      this.isLoadingExportPdf = true;
      const data = {
        nominationId: this.$route.query.id ? Number(this.$route.query.id) : null
      }

      await downloadAfterLoadingFormsPdf(data).then((res) => {
        if (res) {
          downloadFile(res, "after-loading-forms-nomination-" + data.nominationId + ".pdf")
        }
      }).catch((error) => {
        // this.$message.error('Error downloading PDF:' + error);
      });
      this.isLoadingExportPdf = false;
    },
    handlsignsubmitClick() {
      this.$refs.documentdialog.open();
    },
  }
}
</script>
<style scoped lang="scss">
* {
  font-size: 12px;
}

.content {
  border: 1px solid #D5DDED;
  background-color: #fff;
}

.item {
  position: relative;
  min-height: 20px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  border-right: none;

  div {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.active {
  background-color: #203447;
  color: #fff;
  font-weight: 700;
}

.active.start {
  border-top-left-radius: 10px;
}

.active.end {
  border-top-right-radius: 10px;
}

.activeChild {
  div {
    font-weight: 600 !important;
  }

  .name {
    color: #008CDB;
  }
}

.activeChild::after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 5px;
  background-color: #008CDB;
  transition: all .15s;
}

.start {
  border-left: none;
}

.end {
  border-right: none;
}

::v-deep .el-table {
  border: 1px solid #EBEEF5;
  border-bottom: none;
}

::v-deep .el-table th.el-table__cell.is-leaf,
.el-table td.el-table__cell {
  border-bottom: 1px solid #EBEEF5 !important;
}

::v-deep .el-table td.el-table__cell {
  border-bottom: 1px solid #EBEEF5 !important;

  .cell {
    font-size: 12px;
    font-weight: 600;
    color: #82889C;
  }
}

::v-deep th.el-table__cell {
  background-color: #F4F8FB;
}

::v-deep th.el-table__cell {
  .cell {
    background: #F4F8FB;
    color: #4C565C;
    font-size: 13px;
    font-weight: 500
  }
}

.light {
  //background-color: #8BFF89 !important;

  div {
    //color: #0CB509 !important;
  }
}

.circle {
  width: 12px;
  height: 12px;
  border: 2px solid #CFCFCF;
  border-radius: 50%;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    color: #fff;
  }
}

.before-form {
  margin-top: -1.25rem;
}

.sidebar-item {
  padding: 10px;
  margin-inline: 10px;
  margin-top: 10px;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.sidebar-item.active {
  background-color: #008cdb;
  color: #ffffff;
  font-weight: bold;
}

.sidebar-content {
  flex: 1;
  background-color: #F4F8FB;
  padding: 20px;
  margin-inline: 10px;
  margin-bottom: 10px;
  border: 1px solid #D5DDED;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
</style>
